const defaultConfig = {
  appUrl: process.env.VITE_APP_URL,
  financeAppUrl: process.env.VITE_FINANCE_APP_URL || 'http://localhost:4000',
  apiEndpoint: process.env.VITE_API_ENDPOINT || 'http://localhost:3099/',
  serviceEndpoint:
    process.env.VITE_SERVICE_ENDPOINT || 'http://localhost:3008/',
  subscriptionsEndpoint:
    process.env.VITE_SUBSCRIPTIONS_ENDPOINT ||
    'ws://localhost:3011/subscriptions',
  identityEndpoint:
    process.env.VITE_IDENTITY_ENDPOINT || 'http://localhost:3003/',
  featureFlagServiceClientId:
    process.env.VITE_FEATURE_FLAG_SERVICE_CLIENT_ID ||
    '6260be9f41b3481588213f7e',
  shootstaDomainSegments:
    process.env.VITE_SHOOTSTA_DOMAIN_SEGMENTS ||
    '0c7d217c-7ffa-4c88-a893-196e701f3c65',
  ssoApiEndpoint:
    process.env.VITE_SSO_API_ENDPOINT || 'http://localhost:8081/saml/',
  skipNotifications: process.env.VITE_SKIP_NOTIFICATIONS || 'false',
  DOWNLOAD_MAC_APP_LINK: process.env.VITE_DOWNLOAD_MAC_APP_LINK || undefined,
  socketEndpoint: process.env.VITE_SOCKET_ENDPOINT || 'http://localhost:3026',
  thumbnailsEndpoint:
    process.env.VITE_THUMBNAILS_ENDPOINT || 'http://localhost:3028',
  cueAppEndpoint:
    process.env.VITE_CUE_APP_ENDPOINT || 'http://cue.localhost:4002'
};

export default defaultConfig;
